import { FrameWorkChange, FrameWorkGetDefaulValue, FrameWorkGetPrimaryColorButton, FrameWorkGetSecundaryColorButton, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkMessageSuccessAlert, FrameWorkPutTextToActiveInactiveUser, FrameWorkPutTextToCheck, FrameWorkPutValueIfEditByDefault, FrameWorkSimpleMessageState, FrameWorkVerifyDataIsCompleted, OrdenExpressGetCurrentUser, OrdenExpressIsAdmin, OrdenExpressNavegatePath, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork.js';
import { setDataUserForEdit, setMessageSaveState } from 'orden_express/users/usersActions.js';
import { requestSaveUser } from 'orden_express/users/usersEpic.js';
import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, CardFooter, CardHeader, CardTitle, FormGroup, Input, Label } from 'reactstrap';
import { bindActionCreators } from 'redux';


class UsersForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      typeIdentificationState: '',
      typeIdentification: '',
      userIdState: '',
      userId: '',
      userIdentificationState: '',
      userIdentification: '',
      userName: '',
      userNameState: '',
      phone: '',
      phoneState: '',
      userEmail: '',
      userEmailState: '',
      userPassword: '',
      userPasswordState: '',
      userType: '',
      userTypeState: '',
      userActive: '',
      userActiveState: '',
      userDeliveryPoints: '',
      userDeliveryPointsState: '',
      receiveOrderState: '',
      receiveOrder: '',
      receiveNotificationState: '',
      receiveNotification: '',
      viewPassword: 0,
    };
    OrdenExpressValidateSecurity(this);
    //Cuando no es el administrador se debe permitir sólo editar los datos propios del usuario actual
    if (!OrdenExpressIsAdmin(this)) {
      this.props.setDataUserForEdit(OrdenExpressGetCurrentUser(this));
    }
  }

  /**
   * Se ejecuta justo después de que el componente se ha imlementado y
   * renderizado la primera vez.
   */
  componentDidMount() {

    var dataUserForEdit = this.props.userReducerState.dataUserForEdit;
    if (!OrdenExpressIsAdmin(this)) {
      dataUserForEdit = OrdenExpressGetCurrentUser(this);
    }

    FrameWorkPutValueIfEditByDefault(this, 'typeIdentification', dataUserForEdit, 'typeIdentification', 'have-content', '1');
    FrameWorkPutValueIfEditByDefault(this, 'userId', dataUserForEdit, 'id', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'userIdentification', dataUserForEdit, 'identification', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'userName', dataUserForEdit, 'name', 'have-content', 4);
    FrameWorkPutValueIfEditByDefault(this, 'phone', dataUserForEdit, 'phone', 'have-content', 7);
    FrameWorkPutValueIfEditByDefault(this, 'userEmail', dataUserForEdit, 'email', 'email');
    FrameWorkPutValueIfEditByDefault(this, 'userPassword', dataUserForEdit, 'password', 'have-content', '4');
    FrameWorkPutValueIfEditByDefault(this, 'userType', dataUserForEdit, 'profile', 'have-content', '1');
    FrameWorkPutValueIfEditByDefault(this, 'userActive', dataUserForEdit, 'active', 'have-content', '1');
    FrameWorkPutValueIfEditByDefault(this, 'receiveNotification', dataUserForEdit, 'receiveNotification', 'have-content', '1');
    FrameWorkPutValueIfEditByDefault(this, 'receiveOrder', dataUserForEdit, 'receiveOrder', 'have-content', '1');

    if (dataUserForEdit === null) {
      this.setState({ userActive: 1 });
      this.setState({ receiveNotification: 1 });
      this.setState({ receiveOrder: 1 });
    } else {
      try {
        this.setState({ typeIdentification: { value: dataUserForEdit.typeIdentification, label: dataUserForEdit.typeIdentification } });
      } catch (__) { }
    }
  }

  /**
   * Cuando cambia una variable del estado se ejecuta este método,
   * en él se verifica el cambio buscado y se realizan las operaciones
   * de estado deseadas.
   * @param {*} prevProps 
   */
  componentDidUpdate(prevProps) {
    if (this.props.userReducerState.messageSaveState !== prevProps.userReducerState.messageSaveState) {
      this.processMessageState(this.props.userReducerState.messageSaveState);
    }
  }

  /**
   * Con éste método se genera el contenido de un bean que representa a un usuario
   * para su proceso de envío hacia el backend
   */
  getDataFromForm = (sendEmail = false) => {
    const user = {
      id: this.state.userId,
      typeIdentification: this.state.typeIdentification.value,
      phone: this.state.phone,
      email: this.state.userEmail,
      profile: this.state.userType,
      identification: this.state.userIdentification,
      name: this.state.userName,
      password: this.state.userPassword,
      active: 1,
      receiveOrder: 1,
      receiveNotification: 1,
      sendEmail: sendEmail,//cuando este campo está en true significa el envío de correo recordando los datos de acceso
    };
    user.active = 0;
    user.receiveOrder = 0;
    user.receiveNotification = 0;
    if (this.state.userActive) {
      user.active = 1;
    }
    if (this.state.receiveOrder) {
      user.receiveOrder = 1;
    }
    if (this.state.receiveNotification) {
      user.receiveNotification = 1;
    }
    return user;
  }

  /**
   * Valida los campos obligatorios y ayuda a determinar
   * en ellos con un color o etiqueta visual para que el 
   * usuario los identifique
   */
  verifyData = (sendEmail = false) => {
    var dataIsCompleted = true;
    const listValidation = [
      'typeIdentificationState',
      'userIdentificationState',
      'userNameState',
      'phoneState',
      'userEmailState',
      'userPasswordState',
      'userTypeState'];
    var pos=0;
    var length=listValidation.length;
    while(pos<length){
      var item=listValidation[pos];
      if (FrameWorkVerifyDataIsCompleted(this.state[item])) {
        dataIsCompleted = false;
        this.setState({ [item]: 'has-danger' });
      }
      pos++;
    }
    if (!dataIsCompleted) {
      FrameWorkMessageErrorAlert(this, 'Faltan datos', 'Debe ingresar todos los datos solicitados')
      return;
    }
    //Al llear a este punto es que todos los datos han sido ingresados y se procede a su registro
    this.props.requestSaveUser(this.getDataFromForm(sendEmail));
    this.props.setMessageSaveState(1);
  };

  endOfSavingData = () => {
    if (OrdenExpressIsAdmin(this)) {
      this.props.history.goBack();
    } else {
      OrdenExpressNavegatePath(this, 'Logout');
    }
  }
  /**
   * Controla la secuencia de estados para visualizar 
   * los mensajes en el proceso de almacenamiento de un usuario
   */
  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Grabando', 'Su solicitud está en proceso ...');
        break;
      case 2:
        FrameWorkMessageSuccessAlert(this, 'Correcto!', 'Los datos fueron correctamente almacenados', this.endOfSavingData, this.endOfSavingData);
        break;
      case 3:
        var localMessageError = this.props.userReducerState.responseSaveUser;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        console.error(localMessageError)
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageSaveState(0);
        break;
    }
  }

  renderCheckForAdministrator = (pTypeUser, dataUserForEdit) => {
    if (pTypeUser === 'Administrador') {
      return (
        <FormGroup check className='mt-2'>
          <Label check>
            <Input
              name='receiveOrder'
              type='checkbox'
              defaultChecked={dataUserForEdit === null ? 1 : FrameWorkGetDefaulValue(dataUserForEdit, 'receiveOrder')}
              onChange={value => { this.setState({ receiveOrder: !this.state.receiveOrder }); }} />
            <span className='form-check-sign' />
            {FrameWorkPutTextToCheck(this.state.receiveOrder, 1, 'Recibir correo con las solicitudes de los usuarios', 'No recibe correos')}
          </Label>
        </FormGroup>
      );
    }
    return ('');
  }

  renderActiveForAdmin = (dataUserForEdit) => {
    if (!OrdenExpressIsAdmin(this)) {
      return (<></>);
    }
    return (
      <FormGroup check className='mt-2'>
        <Label
          check
        >
          <Input
            name='optionCheckboxes'
            type='checkbox'
            defaultChecked={dataUserForEdit === null ? 1 : FrameWorkGetDefaulValue(dataUserForEdit, 'active')}
            onChange={value => { this.setState({ userActive: !this.state.userActive }); }} />
          <span className='form-check-sign' />
          {FrameWorkPutTextToActiveInactiveUser(this.state.userActive, 1)}
        </Label>
      </FormGroup>
    )
  }

  renderTypeOfUserForAdmin = (userTypeState, dataUserForEdit) => {
    if (!OrdenExpressIsAdmin(this)) {
      return (<></>);
    }
    return (
      <>
        <FormGroup className={`has-label ${userTypeState}`}>
          <label>Tipo *</label>
          <Select
            className={`react-select ${userTypeState === 'has-danger' ? 'bg-danger-drop-down' : ''}`}
            classNamePrefix='react-select'
            name='userType'
            value={(this.state.singleSelect === '' || this.state.singleSelect === undefined || this.state.singleSelect === null) ? { value: FrameWorkGetDefaulValue(dataUserForEdit, 'profile'), label: FrameWorkGetDefaulValue(dataUserForEdit, 'profile') } : this.state.singleSelect}
            onChange={value => {
              this.setState({ singleSelect: value });
              FrameWorkChange(this, value.value, 'userType', 'have-content', '1');
            }
            }
            options={
              [
                { value: 'Administrador', label: 'Administrador' },
                { value: 'Cliente', label: 'Cliente' }
              ]}
            placeholder='Seleccione el tipo de usuario'
          />
          {this.state.userTypeState === 'has-danger' ? (
            <label className='error'>
              Seleccione el tipo de usuario
                  </label>
          ) : null}
        </FormGroup>
        {this.renderCheckForAdministrator(this.state.userType, dataUserForEdit)}
      </>
    )
  }

  /**
   * Pinta los contenidos basados en los estados
   */
  render() {
    let {
      typeIdentificationState,
      userIdentificationState,
      userNameState,
      phoneState,
      userEmailState,
      userPasswordState,
      userTypeState,
    } = this.state;
    let dataUserForEdit = this.props.userReducerState.dataUserForEdit;
    return (
      <div className='content'>
        {this.state.alert}
        <Card>
          <CardHeader>
            <CardTitle tag='h5'>Datos del usuario</CardTitle>
          </CardHeader>
          <CardBody>
            <Input
              name={this.state.userXXXField}
              type='text'
              value={FrameWorkGetDefaulValue(dataUserForEdit, 'id')}
              hidden
              readOnly
            />
            <FormGroup className={`has-label ${typeIdentificationState}`}>
              <label>Tipo identificación*</label>
              <Select
                className={`react-select ${typeIdentificationState === 'has-danger' ? 'bg-danger-drop-down' : ''}`}
                classNamePrefix='react-select'
                name='typeIdentification'
                value={(this.state.typeIdentification === '' || this.state.typeIdentification === undefined || this.state.typeIdentification === null) ? { value: FrameWorkGetDefaulValue(dataUserForEdit, 'typeIdentification'), label: FrameWorkGetDefaulValue(dataUserForEdit, 'typeIdentification') } : this.state.typeIdentification}
                onChange={value => {
                  this.setState({ typeIdentification: value });
                  FrameWorkChange(this, value, 'typeIdentification', 'have-content', '1');
                }
                }
                options={
                  [
                    { value: 'CC', label: 'CC' },
                    { value: 'NIT', label: 'NIT' },
                    { value: 'CE', label: 'CE' },
                    { value: 'Pasaporte', label: 'Pasaporte' },
                    { value: 'Visa', label: 'Visa' },
                  ]}
                placeholder='Seleccione el tipo de identificación'
              />
              {this.state.typeIdentificationState === 'has-danger' ? (
                <label className='error'>
                  Seleccione el tipo de identificación del usuario
                  </label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${userIdentificationState}`}>
              <label>Identificación *</label>
              <Input
                name='userIdentification'
                type='text'
                maxLength='80'
                defaultValue={FrameWorkGetDefaulValue(dataUserForEdit, 'identification')}
                onChange={e => FrameWorkChange(this, e.target.value, 'userIdentification', 'have-content', '1')}
              />
              {this.state.userIdentificationState === 'has-danger' ? (
                <label className='error'>
                  Ingrese la identificación del usuario
                  </label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${userNameState}`}>
              <label>Nombre *</label>
              <Input
                name='userName'
                type='text'
                maxLength='80'
                defaultValue={FrameWorkGetDefaulValue(dataUserForEdit, 'name')}
                onChange={e => FrameWorkChange(this, e.target.value, 'userName', 'have-content', 4)}
              />
              {this.state.userNameState === 'has-danger' ? (
                <label className='error'>
                  Ingrese el nombre del usuario
                  </label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${phoneState}`}>
              <label>Teléfono *</label>
              <Input
                name='phone'
                type='text'
                maxLength='20'
                defaultValue={FrameWorkGetDefaulValue(dataUserForEdit, 'phone')}
                onChange={e => FrameWorkChange(this, e.target.value, 'phone', 'have-content', '7')}
              />
              {this.state.phoneState === 'has-danger' ? (
                <label className='error'>
                  Digite un número con almenos 7 caracteres
                  </label>
              ) : null}
            </FormGroup>
            <FormGroup className={`has-label ${userEmailState}`}>
              <label>Correo electrónico *</label>
              <Input
                name='email'
                type='email'
                maxLength='80'
                defaultValue={FrameWorkGetDefaulValue(dataUserForEdit, 'email')}
                onChange={e => FrameWorkChange(this, e.target.value, 'userEmail', 'email')}
              />
              {this.state.userEmailState === 'has-danger' ? (
                <label className='error'>
                  Por favor ingerse un correo electrónico válido
                  </label>
              ) : null}
            </FormGroup>
            <FormGroup check className='mt-2'>
              <Label check>
                <Input
                  name='optionCheckboxes'
                  type='checkbox'
                  defaultChecked={this.state.viewPassword}
                  onChange={value => { this.setState({ viewPassword: this.state.viewPassword === 0 ? 1 : 0 }); }} />
                <span className='form-check-sign' />
                {this.state.viewPassword === 1 ? 'Ver clave' : 'Ocultar clave'}
              </Label>
            </FormGroup>
            <FormGroup className={`has-label ${userPasswordState}`}>
              <label>Clave *</label>
              <Input
                name='userPassword'
                type={this.state.viewPassword === 0 ? 'password' : 'text'}
                maxLength='80'
                defaultValue={FrameWorkGetDefaulValue(dataUserForEdit, 'password')}
                onChange={e => FrameWorkChange(this, e.target.value, 'userPassword', 'have-content', '4')}
              />
              {this.state.userPasswordState === 'has-danger' ? (
                <label className='error'>
                  Ingrese la clave del usuario mínimo 4 caracteres
                  </label>
              ) : null}
            </FormGroup>

            {this.renderTypeOfUserForAdmin(userTypeState, dataUserForEdit)}

            <FormGroup check className='mt-2'>
              <Label check>
                <Input
                  name='receiveNotification'
                  type='checkbox'
                  defaultChecked={dataUserForEdit === null ? 1 : FrameWorkGetDefaulValue(dataUserForEdit, 'receiveNotification')}
                  onChange={value => { this.setState({ receiveNotification: !this.state.receiveNotification }); }} />
                <span className='form-check-sign' />
                {FrameWorkPutTextToCheck(this.state.receiveNotification, 1, 'Recibir notificaciones', 'Sin notificaciones')}
              </Label>
            </FormGroup>

            {this.renderActiveForAdmin(dataUserForEdit)}

            <div className='category form-category'>
              * Campos obligatorios
              </div>

          </CardBody>
          <CardFooter className='text-right'>
            <Button
              color={FrameWorkGetSecundaryColorButton()}
              className='btn-round mb-0'
              style={{ width: 145, height: 50 }}
              onClick={() => {
                try {
                  this.props.history.goBack();
                } catch (_) {
                  //this.props.history.push('admin/users');
                  OrdenExpressNavegatePath(this, 'users');
                }
              }
              }>
              <i className='icon-big nc-icon nc-minimal-left text-white' />
              Regresar
              </Button>

            <Button

              className='btn-round mt-1 mb-0 ml-4'
              color={FrameWorkGetPrimaryColorButton()}
              style={{ width: 145, height: 50 }}
              onClick={() => {
                this.verifyData();
              }
              }>
              <i className='icon-big fa fa-save text-white' />
              Grabar
              </Button>

            <Button
              hidden={!OrdenExpressIsAdmin(this)}
              className='btn-round mt-1 mb-0 ml-4'
              color={FrameWorkGetPrimaryColorButton()}
              style={{ width: 145, height: 50 }}
              onClick={() => {
                this.verifyData(true);
              }
              }>
              <i className='icon-big fa fa-save text-white' />
              Grabar y Notificar
              </Button>
          </CardFooter>
        </Card>
      </div>
    );
  }
}
/**
 * Gracias a este método se tiene acceso al repositorio de estados único,
 * para este caso se usa el del usuario
 * @param {*} state 
 */
const mapStateToProps = state => {
  return {
    userReducerState: state.userReducerState,
    loginReducerState: state.loginReducerState
  };
};

/**
 * Gracias a este método se pueden cambiar los estados globales
 * también permite acceder a las solicitudes del Epic para su
 * procesamiento en el backend
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
  return {
    setDataUserForEdit: (dataUserForEdit) => dispatch(setDataUserForEdit(dataUserForEdit)),
    setMessageSaveState: messageSaveState => dispatch(setMessageSaveState(messageSaveState)),

    requestSaveUser: dataUser => bindActionCreators(dispatch(requestSaveUser(dataUser)), dispatch),
  };
};

/**
 * Responde con el componente general del Usuario en su parte del formulario de datos
 */
export default connect(mapStateToProps, mapDispatchToProps)(UsersForm);